module.exports = __webpack_public_path__ + "static/img/is-upgrade.db80479.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/is-upgrade.png
// module id = Br5N
// module chunks = 1